/**
 * ReportEvent 组件
 * 用于包装需要进行埋点上报的元素
 *
 * 注意:
 * 1. 这是一个客户端组件 ('use client')
 * 2. 适用于需要在服务器组件中进行埋点上报的场景
 * 3. 通过包装子元素的方式来监听点击事件
 *
 * @example
 * <ReportEvent eventName="element_click" params={{ element_name: 'submit_button' }}>
 *   <button>提交</button>
 * </ReportEvent>
 */
'use client';

import { cloneElement, type FC, type PropsWithChildren } from 'react';
import { reportEvent } from '@/app/utils';

export const ReportEvent: FC<
  PropsWithChildren<{
    eventName: string;
    params?: Record<string, string>;
    asChild?: boolean;
  }>
> = ({ children, eventName, params, asChild = false }) => {
  if (asChild) {
    const child = children as React.ReactElement<{ onClick?: (e: React.MouseEvent) => void }>;
    return cloneElement(child, {
      onClick: (e: React.MouseEvent) => {
        child.props?.onClick?.(e);
        reportEvent(eventName, params);
      },
    });
  }
  return <div onClick={() => reportEvent(eventName, params)}>{children}</div>;
};
